import ColumnWrapper from 'Layout/ColumWraper';
// import Preloader from 'Layout/Preloader';
import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import SidebarLegalInfo from 'Layout/LegalPages/SidebarLegalInfo';
import ResourceContent from 'pages/Resources/ResourceContent';
import { useRef } from 'react';
import { useAnimation } from 'hooks/useAnimation';
import Helmet from 'react-helmet';

const LegalPages = ({ loading, title, blocks, updatedAt, metaTags, metaTitle = null }) => {
    const container = useRef();
    useAnimation({
        items: ['.resources-title h2'],
        container,
        dependencies: [loading],
    });

    return (
        <>
            <Helmet title={metaTitle ? `${metaTitle}` : title} meta={metaTags} />
            <section ref={container} className="inner-container resources-title">
                <HeroCrumbs page={title} />
                <h2>{title}</h2>
            </section>
            <ColumnWrapper SideText={<SidebarLegalInfo loading={loading} />}>
                <ResourceContent content={blocks} lastUpdate={updatedAt} loading={loading} />
            </ColumnWrapper>
        </>
    );
};

export default LegalPages;
